import { render, staticRenderFns } from "./MobileSetting.vue?vue&type=template&id=70dbeac2&"
import script from "./MobileSetting.vue?vue&type=script&lang=js&"
export * from "./MobileSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports